<template>
  <router-view />
</template>

<script>
export default {}
</script>

<style lang="sass">
@import "styles/index"
</style>
